import { ArrowRight, Phone } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { scrollToId } from "@/lib/site";

export default function CtaSection({ onQuote }) {
  return (
    <section data-testid="cta-section" className="relative overflow-hidden bg-navy py-24 lg:py-32">
      <div className="jtk-dotgrid pointer-events-none absolute inset-0 opacity-50" />
      <div className="pointer-events-none absolute left-1/2 top-1/2 h-[560px] w-[860px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-electric/15 blur-[150px]" />
      <div className="pointer-events-none absolute bottom-0 left-1/4 h-[280px] w-[280px] rounded-full bg-cyan-500/15 blur-[110px]" />

      <div className="relative mx-auto max-w-4xl px-5 text-center lg:px-8">
        <Reveal>
          <p className="font-mono text-xs font-semibold uppercase tracking-[0.3em] text-cyan-400">
            Connecting Today. Building Tomorrow.
          </p>
          <h2 className="mt-5 font-heading text-3xl font-bold tracking-tight text-white sm:text-4xl lg:text-5xl">
            Let&apos;s Build Your Next Connection.
          </h2>
        </Reveal>
        <Reveal delay={0.12}>
          <p className="mx-auto mt-6 max-w-2xl text-base leading-relaxed text-slate-400 md:text-lg">
            Whether you need optical fiber, networking equipment, telecom power systems,
            OFC civil works, fiber leasing or connectivity infrastructure, JAYTRIKA is
            ready to support your requirement.
          </p>
        </Reveal>
        <Reveal delay={0.2}>
          <div className="mt-10 flex flex-wrap items-center justify-center gap-4">
            <button
              data-testid="cta-request-quote-button"
              onClick={() => onQuote()}
              className="group inline-flex items-center gap-2.5 rounded-full bg-electric px-8 py-4 text-sm font-semibold text-white shadow-xl shadow-blue-600/30 transition-all duration-300 hover:-translate-y-0.5 hover:bg-blue-500 hover:shadow-blue-500/50"
            >
              Request a Quote
              <ArrowRight size={16} className="transition-transform duration-300 group-hover:translate-x-1" />
            </button>
            <button
              data-testid="cta-talk-button"
              onClick={() => scrollToId("contact")}
              className="inline-flex items-center gap-2.5 rounded-full border border-white/20 bg-white/[0.06] px-8 py-4 text-sm font-semibold text-white backdrop-blur-md transition-all duration-300 hover:-translate-y-0.5 hover:border-cyan-400/40 hover:bg-white/10"
            >
              <Phone size={16} className="text-cyan-300" />
              Talk to Our Team
            </button>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
